module.exports = __webpack_public_path__ + "img/user1.08539d29.png";